import script from "./OrgDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgDashboard.vue?vue&type=script&setup=true&lang=js"

import "./OrgDashboard.vue?vue&type=style&index=0&id=cc048cd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc048cd6"]])

export default __exports__